import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import ValidView from "../../components/app/validView";
import InformationCards from "./InformationCards.js";
import CustomDatePicker from './CustomDatePicker';
import Spinner from '../utils/Spinner';
import dateToISOString from '../../components/app/dateToISOString';

export function Subscriptions() {

  const { allowWrite, allowView, userToken } = ValidView("Reports");
  const [isLoading, setIsLoading] = useState(true);
  const [timer, setTimer] = useState(null);

  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

  const [dates, setDates] = useState({
    startDate: new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0, 0),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999),
  });

  const [cardData, setCardData] = useState([
    {
      key: 'expirations',
      type: 'Warning',
      label: 'Next Expirations',
      text: 'Subscriptions about to expire this month.',
      count: 0
    },
    {
      key: 'expired',
      type: 'Info',
      label: 'Expired',
      text: 'Subscriptions expired in the month to date.',
      count: 0
    },
    {
      key: 'renewed',
      type: 'Success',
      label: 'Renewed',
      text: 'Subscriptions renewed in the month to date.',
      count: 0
    }
  ]);

  useEffect(() => {
    if (userToken) {
      fetchOrdersReport(dates.startDate, dates.endDate);
    }
  }, [userToken]);

  const fetchOrdersReport = async (startDate, endDate) => {
    try {
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + userToken }
      };

      const startDateISOString = dateToISOString(startDate);
      const endDateISOString = dateToISOString(endDate, true);

      const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/reports/countSubscriptions/' + `${startDateISOString}/${endDateISOString}` + '', requestOptions);
      const arrResponse = await response.json();

      if (!arrResponse?.data) {
        setIsLoading(false);
        return
      };

      const data = arrResponse.data;
      const updatedCardData = cardData.map(card => ({
        ...card,
        count: data[card.key]
      }));

      setCardData(updatedCardData);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching subscription counts:', error);
    }
  };

  const handlerDates = () => {
    setIsLoading(true);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        setDates({ startDate: new Date(dates.startDate), endDate: new Date(dates.endDate) });
        fetchOrdersReport(dates.startDate, dates.endDate);
      }, 1500)
    );
  };

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Container fluid className='dashboard'>
        <CustomDatePicker dates={dates} setDates={setDates} handlerDates={handlerDates} />
        <InformationCards cardData={cardData} />
      </Container>
    </>
  );
}